import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import ErrorBoundary from '../../../../Utility/Components/ErrorBoundary';
import { connect } from 'react-redux';
import { loaderStateTrue, loaderStateFalse } from '../../../../Actions/AllAction';
import { withNamespaces } from 'react-i18next';
import CustomInput from '../../../../Utility/Components/CustomInput';
import ModalGlobal from '../../../../Utility/Components/ModalGlobal';
import Utility from '../../../../Utility/Utility';
import { Country } from 'country-state-city';
import { updatePersonDetails } from '../Controller/HomeController'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

function PersonDetailsModalContent(props) {
    const bookingDetailsRef = useRef(true);
    const [personData, setPersonData] = useState([]);
    const [personDataError, setPersonDataError] = useState([]);
    const [identityTypeList, setIdentityTypeList] = useState([
        { label: "Passport", value: "passport" },
        { label: "PAN Card", value: "pan_card" },
        { label: "Aadhaar card", value: "aadhar_card" },
        { label: "Identity card", value: "identity_card" },
        { label: "Driving licence", value: "driving_licence" },
    ]);
    const [adultCount, setAdultCount] = useState(0);
    const [childCount, setChildCount] = useState(0);
    const [childAge, setChildAge] = useState([]);
    const [childAgeLimit, setChildAgeLimit] = useState(9);
    const [countryList, setCountryList] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedImage, setSelectedImage] = useState("");

    useEffect(() => {
        viewBookingDetailsApiFn();
    }, [props.adult, props.child, props.child_age]);

    useEffect(() => {
        // console.log("props.editedFlag=======", props.editedFlag)
        // console.log("props.editedFlag=======2", props.fetchedPersonData)
        if (props.editedFlag && props.fetchedPersonData?.length > 0) {
            const mappedData = props.fetchedPersonData.map(person => {
                const [firstName = "", ...rest] = (person.customer_name ?? "").split(" ");
                const lastName = rest.join(" ").trim();
                return {
                    first_name: firstName,
                    last_name: lastName,
                    age: person.customer_age ? String(person.customer_age) : "",
                    type: person.customer_type || "adult",
                    id: person.id || "",
                    is_edit: false,
                }
            });

            setPersonData(mappedData);
            setPersonDataError(mappedData.map(p => createEmptyError(p.type)));
        } else {
            viewBookingDetailsApiFn();
        }
    }, [props.fetchedPersonData, props.editedFlag]);

    const viewBookingDetailsApiFn = () => {
        setAdultCount(props.adult ?? 0);
        setChildCount(props.child ?? 0);

        let childAgeParsed = props.child_age;
        if (typeof props.child_age === 'string') {
            try {
                childAgeParsed = JSON.parse(props.child_age);
            } catch {
                childAgeParsed = [];
            }
        }
        setChildAge(childAgeParsed ?? []);
        setChildAgeLimit(props.child_age_limit ?? 9);
        initializePersonData(
            props.adult ?? 0,
            props.child ?? 0,
            childAgeParsed ?? []
        );
    };

    const initializePersonData = (adultCountValue, childCountValue, childAgeArray) => {
        const updatedPersonData = [];
        const updatedPersonDataError = [];

        // Adults
        for (let i = 0; i < Number(adultCountValue); i++) {
            if (personData[i] && personData[i].type === "adult") {
                updatedPersonData.push(personData[i]);
                updatedPersonDataError.push(personDataError[i] ?? createEmptyError("adult"));
            } else {
                updatedPersonData.push(createEmptyPerson("adult"));
                updatedPersonDataError.push(createEmptyError("adult"));
            }
        }

        // Children
        for (let i = 0; i < Number(childCountValue); i++) {
            const childIndex = Number(adultCountValue) + i;

            let existingChild = (personData[childIndex] && personData[childIndex].type === "child")
                ? personData[childIndex]
                : createEmptyPerson("child");

            // Always prefer latest childAgeArray value if present
            const ageToSet =
                childAgeArray[i]?.age?.value?.toString() ||
                existingChild.age ||
                "";

            updatedPersonData.push({
                ...existingChild,
                age: ageToSet,
            });

            updatedPersonDataError.push(personDataError[childIndex] ?? createEmptyError("child"));
        }
        setPersonData(updatedPersonData);
        setPersonDataError(updatedPersonDataError);
    };

    const createEmptyPerson = (type, age = "") => ({
        //name: "",
        first_name: "",
        last_name: "",
        age: age,
        type: type,
        is_edit: false,
    });

    const createEmptyError = (type) => ({
        // name: "",
        first_name: "",
        last_name: "",
        age: "",
        type: type,
    });

    useEffect(() => {
        // console.log('personDataError------->', personDataError)
    }, [personDataError])

    //person details input field onchange fn
    const handleInputChange = (e, index, type) => {
        let updatedPersonData = [...personData];
        let updatedPersonDataError = [...personDataError];

        if (type == 'first_name') {
            var expr = /^[a-zA-Z ]*$/;
            if (!expr.test(e.target.value)) {

            } else {
                const { name, value } = e.target;
                if (e.target.value == "") {
                    updatedPersonData[index][name] = "";
                    updatedPersonDataError[index][name] = "";
                } else {
                    updatedPersonData[index][name] = value;
                    updatedPersonDataError[index][name] = "";
                }
            }
        }
        if (type == 'last_name') {
            var expr = /^[a-zA-Z ]*$/;
            if (!expr.test(e.target.value)) {

            } else {
                const { name, value } = e.target;
                if (e.target.value == "") {
                    updatedPersonData[index][name] = "";
                    updatedPersonDataError[index][name] = "";
                } else {
                    updatedPersonData[index][name] = value;
                    updatedPersonDataError[index][name] = "";
                }
            }
        }

        if (type == 'age') {
            var expr = /^[0-9]*$/;
            if (!expr.test(e.target.value)) {

            } else {
                const { name, value } = e.target;
                if (e.target.value == "") {
                    updatedPersonData[index][name] = "";
                    updatedPersonDataError[index][name] = "";
                } else {
                    if (Number(e.target.value) >= 150) {
                        updatedPersonData[index][name] = '';
                        updatedPersonDataError[index][name] = "Please check age";
                    } else {
                        updatedPersonData[index][name] = value;
                        updatedPersonDataError[index][name] = "";
                    }
                }
            }
        }
        updatedPersonData[index]['is_edit_change'] = true;
        setPersonData(updatedPersonData);
        setPersonDataError(updatedPersonDataError);
    };

    //validate person details form
    const validationFromData = () => {
        let valid = true;

        const encounteredIdentityNumbers = {};
        const updatedPersonDataError = personData.map(person => {
            const errors = {};
            return errors;
        });
        setPersonDataError(updatedPersonDataError);
        return valid;
    };

    //person details save api formatting dataset
    const formatingDataset = () => {
        let updatedPersonData = [...personData];
        let updatedPersonDataError = [...personDataError];
        let dataset = [];
        let hash = {}
        updatedPersonData.map((person, index) => {
            hash = {}
            hash['booking_id'] = props.bookingId;
            const firstName = person.first_name?.trim() ?? "";
            const lastName = person.last_name?.trim() ?? "";
            const fullName = [firstName, lastName].filter(Boolean).join(" ");
            hash['customer_name'] = fullName;
            hash['customer_age'] = person.age != "" && person.age != null ? Number(person.age) : "";
            hash['index'] = index + 1;
            hash['customer_type'] = person.type;
            dataset.push(hash);
        })


        return dataset;
    }

    useEffect(() => {
        if (!props.editedFlag) {
            let dataSet = formatingDataset();
            props.getAllDetails(dataSet)
        }
    }, [personData, props.editedFlag])

    //person details modal save fn
    const confirmPersonDetailsModalFn = () => {
        // let valid = validationFromData();
        let valid = true;
        if (valid) {
            let dataSet = formatingDataset();
            // return false;
        }
    }

    useEffect(() => {
    }, [personData])

    const closePersonDetailsModalChild = () => {
        props.closeTravellerDetailsModal()
    }

    //person details edit fn
    const editPersonDetailsFn = (index) => {
        setPersonData(prevPersonData => {
            const updatedPersonData = [...prevPersonData];
            updatedPersonData[index] = {
                ...updatedPersonData[index],
                is_edit: !updatedPersonData[index].is_edit,
                is_edit_change: false,
            };
            return updatedPersonData;
        });
    }

    const formattingUpdatePersonDetailsDatasetFn = (index) => {
        let dataset = {};
        let personDataTemp = [...personData];
        dataset['booking_id'] = props.bookingId;
        dataset['customer_type'] = personDataTemp[index].type;
        const firstName = personDataTemp[index].first_name?.trim() || "";
        const lastName = personDataTemp[index].last_name?.trim() || "";
        dataset['customer_name'] = `${firstName} ${lastName}`;
        dataset['customer_age'] = Number(personDataTemp[index].age);
        return dataset;
    }

    //update person details api fn
    const updatePersonDetailsFn = (index) => {
        if (personData[index].hasOwnProperty('is_edit_change') && personData[index].is_edit_change == true) {
            let valid = true;
            if (valid) {
                let dataset = formattingUpdatePersonDetailsDatasetFn(index);
                let id = personData[index].id;
                // return false
                loaderStateTrue();
                updatePersonDetails(id, dataset).then((response) => {
                    if (response.success) {
                        setPersonData(prevPersonData => {
                            const updatedPersonData = [...prevPersonData];
                            updatedPersonData[index] = {
                                ...updatedPersonData[index],
                                "is_edit": false,
                                "deleted_index": []
                            };
                            return updatedPersonData;
                        });
                        Utility.toastNotifications(response.message, "Success", "success");
                    } else {
                        Utility.toastNotifications(response.message, "Error", "error");
                    }
                    loaderStateFalse();
                }).catch((error) => {
                    console.error("************error*************", error)
                    if (error) {
                    }
                    loaderStateFalse();
                    if (error.message == "Network Error") {

                    }
                });
            }
        } else {
            setPersonData(prevPersonData => {
                const updatedPersonData = [...prevPersonData];
                updatedPersonData[index] = {
                    ...updatedPersonData[index],
                    "is_edit": false,
                    "deleted_index": [],
                    'is_edit_change': false
                };
                return updatedPersonData;
            });
        }
    }

    return (
        <>
            <div className="gridcontainer">
                <div className="modalinnerbody">
                    <div className='guestDetailsRowBoxes'>
                        <div className='col-md-12'>
                            <div className='row'>
                                {personData.map((person, index) => {
                                    let requiredStar = person.name?.trim() !== "" ||
                                        (person.type !== "child" ? person.age?.trim() !== "" : false) ||
                                        person.identity_number?.trim() !== "" ||
                                        person.identity_type?.value ||
                                        (Array.isArray(person.identity_image) && person.identity_image.length > 0 && person.identity_image.some(image => image.image_url !== "")) ||
                                        person.coming_from?.label ||
                                        person.going_to?.label
                                        ? true
                                        : 'require';
                                    const isDisabled = props.editedFlag && !props.isGuestDetailsEditable;
                                    return (
                                            <div className='guestDetailsBox col-md-6 col-sm-12' key={index}>
                                                <fieldset className='cust-guest-details-row'>
                                                    <legend><h2 className='titleBox'>Traveller {index + 1}</h2></legend>
                                                    <div className={"guestDetailsRow"}>
                                                        <div className='row'>
                                                            <div className={
                                                                props.editedFlag && props.fetchedPersonData?.length > 0
                                                                    ? `${!person.is_edit || isDisabled ? "disabled" : ""} ${isDisabled ? "col-md-12" : "col-md-11 col-xs-9"}`
                                                                    : "col-md-12"
                                                            }>
                                                                <div className='row'>
                                                                    <div className='col-sm-4 personName paddingR6'>
                                                                        <CustomInput
                                                                            parentClassName="input_field_inner nameField"
                                                                            labelName="First Name"
                                                                            errorLabel={personDataError[index].first_name}
                                                                            name="first_name"
                                                                            type="text"
                                                                            value={person.first_name}
                                                                            labelPresent={true}
                                                                            onChange={(e) => handleInputChange(e, index, "first_name")}
                                                                            //requiredStar={requiredStar ? true : false}
                                                                            requiredStar={false}
                                                                        />
                                                                    </div>
                                                                    <div className='col-sm-4 personName paddingR6'>
                                                                        <CustomInput
                                                                            parentClassName="input_field_inner nameField"
                                                                            labelName="Last Name"
                                                                            errorLabel={personDataError[index].last_name}
                                                                            name="last_name"
                                                                            type="text"
                                                                            value={person.last_name}
                                                                            labelPresent={true}
                                                                            onChange={(e) => handleInputChange(e, index, "last_name")}
                                                                            //requiredStar={requiredStar ? true : false}
                                                                            requiredStar={false}
                                                                        />
                                                                    </div>
                                                                    <div className='col-sm-4 paddingL6'>
                                                                        <CustomInput
                                                                            parentClassName="input_field_inner ageField"
                                                                            labelName="Age"
                                                                            errorLabel={personDataError[index].age}
                                                                            name="age"
                                                                            type="text"
                                                                            value={person.age}
                                                                            labelPresent={true}
                                                                            onChange={(e) => handleInputChange(e, index, "age")}
                                                                            isDisabled={person.type == "child" ? true : false}
                                                                            // requiredStar={requiredStar ? true : false}
                                                                            requiredStar={false}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {!(props.editedFlag && !props.isGuestDetailsEditable) &&
                                                                props.editedFlag && props.fetchedPersonData?.length > 0 && (
                                                                    <div className='col-md-1 col-xs-3' style={{ position: 'relative' }}>
                                                                        {!person.is_edit &&
                                                                            <OverlayTrigger trigger={['hover', 'click']} rootClose={true} overlay={<Tooltip className="popup-tooltip-box">Edit</Tooltip>}>
                                                                                <button className='editViewBtn editBtnIcon' onClick={() => editPersonDetailsFn(index)}><img src={require('../../../../Utility/Public/images/pencilColor.png')} /></button></OverlayTrigger>

                                                                        }
                                                                        {person.is_edit && (
                                                                            <OverlayTrigger trigger={['hover', 'click']} rootClose={true} overlay={<Tooltip className="popup-tooltip-box">Update</Tooltip>}>
                                                                                <button className="editViewBtn updateBtnIcon" onClick={() => updatePersonDetailsFn(index)}>
                                                                                    <img src={require('../../../../Utility/Public/images/updateIcon.png')} />
                                                                                </button>
                                                                            </OverlayTrigger>
                                                                        )}
                                                                    </div>
                                                                )}

                                                        </div>
                                                    </div>
                                                </fieldset >
                                            </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                    {/* {props.editedFlag && props.fetchedPersonData?.length > 0 ?
                        <div className="col-md-12 text-center topspace">
                            {<button type="button" className="modbtn" onClick={(e) => confirmPersonDetailsModalFn()} >Update</button>}
                            <button type="button" className="modbtn cancelbtn" onClick={(e) => { closePersonDetailsModalChild() }}
                            >Cancel</button>
                        </div> : null} */}
                </div >
            </div >
        </>
    )
}


PersonDetailsModalContent.defaultProps = {
    callFrom: "",
}
const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        token: globalState.LoginReducer.token
    };
}

export default connect(mapStateToProps, { loaderStateTrue, loaderStateFalse })(withNamespaces()(PersonDetailsModalContent));
